import { useFormState } from 'react-final-form';
import { useSelector } from 'react-redux';

import { getAvailableSingleOpportunities } from '@swf/core/models/sports/utils/betSlip/getAvailableOpportunities';
import { select } from '@swf/core/store';
import type {
  MultipleAvailableOpportunity,
  SingleAvailableOpportunity
} from '@swf/generated/types/api/sports';

import type { FormData } from '../types';

import useOddsChanges from './useOddsChanges';

const useDisplayPriceChanges = () => {
  const { values } = useFormState<FormData>();
  const singles = useSelector(select.betSlip.singleOpportunities);
  const { haveOddsChanged } = useOddsChanges();
  const hasAutoAcceptEnabled = useSelector(select.account.hasAutoAcceptEnabled);

  const containsSingleWithNoPrice = getAvailableSingleOpportunities(singles).some(
    (single) => !single.winRunnerOdds
  );
  const containsSingleWithStartingPrice = singles
    .map((single) => values[single.id])
    .some((value) => value && value.startingPriceSelected);

  return {
    displayFooterPriceChanges:
      haveOddsChanged &&
      !hasAutoAcceptEnabled &&
      !containsSingleWithNoPrice &&
      !containsSingleWithStartingPrice,
    displayOpportunityPriceChanges: (
      opportunity: SingleAvailableOpportunity | MultipleAvailableOpportunity,
      predicate: () => boolean
    ) => !hasAutoAcceptEnabled && opportunity.numberOfLines === 1 && predicate()
  };
};

export default useDisplayPriceChanges;
